import { Button } from '../ui/button';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../ui/dialog';
import { CheckCircle, Download, Printer } from 'lucide-react';
import { downloadFile } from '../../utils/download';
import { toast } from 'sonner';
import { useState } from 'react';

export function ChallanModal({ open, onOpenChange, challan }) {
  const [pdfDownloading, setPdfDownloading] = useState(false);

  const downloadChallanPDF = async (challanNumber) => {
    setPdfDownloading(true);
    toast.info('Generating PDF...');
    try {
      const result = await downloadFile(`/api/challan/pdf/${challanNumber}`, `${challanNumber}.pdf`, true);
      if (result.success) {
        toast.success('PDF downloaded!');
      } else {
        toast.error(result.error || 'Failed to download PDF');
      }
    } catch {
      toast.error('Download failed. Please try again.');
    } finally {
      setPdfDownloading(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <CheckCircle className="text-green-600" size={20} />
            Dispatch Created Successfully
          </DialogTitle>
        </DialogHeader>

        {challan && (
          <div className="space-y-4">
            <div className="p-4 bg-zinc-50 border border-zinc-200 rounded-sm text-center">
              <p className="text-xs uppercase tracking-wider text-zinc-500 mb-1">Challan Number</p>
              <p className="font-mono text-2xl font-bold text-[#09090B]" data-testid="challan-number">
                {challan.challan_number}
              </p>
              <p className="text-sm text-zinc-600 mt-2">
                {challan.items_count} item(s) - {challan.total_quantity} total units
              </p>
            </div>

            <div className="flex gap-3">
              <Button
                variant="outline"
                className="flex-1 h-9 rounded-sm"
                onClick={() => downloadChallanPDF(challan.challan_number)}
                disabled={pdfDownloading}
                data-testid="download-challan-pdf"
              >
                {pdfDownloading ? (
                  <>
                    <span className="w-4 h-4 border-2 border-zinc-400 border-t-transparent rounded-full animate-spin mr-2"></span>
                    Downloading...
                  </>
                ) : (
                  <>
                    <Download size={14} className="mr-2" />
                    Download PDF
                  </>
                )}
              </Button>
              <Button
                variant="outline"
                className="flex-1 h-9 rounded-sm"
                onClick={() => window.print()}
                data-testid="print-challan"
              >
                <Printer size={14} className="mr-2" />
                Print
              </Button>
            </div>

            <Button
              className="w-full h-9 rounded-sm bg-[#09090B] hover:bg-[#27272A]"
              onClick={() => onOpenChange(false)}
            >
              Continue Dispatching
            </Button>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
}
